import { render } from "./DrawerDialog.vue?vue&type=template&id=5945e115&scoped=true&ts=true"
import script from "./DrawerDialog.vue?vue&type=script&lang=ts"
export * from "./DrawerDialog.vue?vue&type=script&lang=ts"

import "./DrawerDialog.vue?vue&type=style&index=0&id=5945e115&scoped=true&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5945e115"]])

export default __exports__